import { injectable, injectFromBase } from 'inversify'
import type { Endpoint } from '@/services/endpoints'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import OrmApiSettingsRepository from '@/data/repositories/ormApiSettingsRepository'
import UiSettings from '@/data/models/domain/UiSettings'
import type { ModelRaw } from '@/types'
import { TmIncorrectContractError } from '@/core/error/tmIncorrectContractError'

@RepoSettings<Endpoint>({
  model: UiSettings,
})
@injectable()
@injectFromBase()
export default class UiSettingsRepository extends OrmApiSettingsRepository<UiSettings> {
  public async fetchSettings() {
    const path = this.endpointsService.getPath('uiSettingsNew')
    const response = await this.getApiSource().get<ModelRaw<UiSettings>>(path)
    if (!response.data) {
      throw new TmIncorrectContractError('Response data expected')
    }
    return this.insertOrUpdate([{ ...response.data, id: this.id }])
  }

  public insertOrUpdateSettings(settings: Partial<ModelRaw<UiSettings>>) {
    return this.insertOrUpdate([{ ...settings, id: this.id }])
  }

  public async updateSettings(settings: Partial<ModelRaw<UiSettings>>) {
    const path = this.endpointsService.getPath('uiSettings')
    await this.getApiSource().patch(path, settings)
    await this.insertOrUpdate([{ ...settings, id: this.id }])
  }
}
